<template>
  <div>
    {{ formatNumber(perHour, true) }}
  </div>
</template>

<script>

import {formatNumber} from "@/extensions/filters/filters"

export default {
  name: "ReportStatDoctorsDatatableHtmlPerHourTotal",
  components: {
  },
  props: {
    object: {
      type: Object
    },
    field: {
      type: Object
    },
  },
  computed: {
    perHour() {
        return this.object.hours > 0 ? Math.round(this.object.revenue / this.object.hours) : 0
      }
  },
  methods: {
    formatNumber
  }
}
</script>
